import { useEffect } from "react"
import GtmPageviewTitleId from '../gtm/types/GtmPageviewTitleId';
import GoogleTagManager from '../gtm/GoogleTagManager';
import AppLogger from "../app/AppLogger";


const usePageview = (title: GtmPageviewTitleId) => {
    useEffect(() => {
        GoogleTagManager.fireEventPageview(title);
        AppLogger.info(`PageTitle ${title}`);
    }, [title]);
};

export default usePageview;

